module.exports = __webpack_public_path__ + "static/media/LGSmartBold__W.5e4aa1b3.woff2";